import { cn } from "@/shared/lib/cn";

type Option<T extends string> = { value: T; label: string; icon?: React.ReactNode };

export function Segmented<T extends string>({
  value, onChange, options, className,
}: { value: T; onChange: (v: T) => void; options: Option<T>[]; className?: string }) {
  return (
    <div className={cn("inline-flex items-center p-1 bg-ink-6 rounded-pill gap-1", className)}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={cn(
            "inline-flex items-center gap-1.5 px-3 py-1 rounded-pill text-[13px] font-display font-semibold transition-colors",
            value === o.value
              ? "bg-white text-ink shadow-sm"
              : "text-ink-60 hover:text-ink",
          )}
        >
          {o.icon}
          {o.label}
        </button>
      ))}
    </div>
  );
}
